import { InstanceLogger } from 'src/services/runtime/operationsLog';


export class Runnable {
  constructor(meta, parent = null) {
    const { logger: globalLogger } = meta;

    this.meta = meta;
    this.parent = parent;
    this.globalLogger = globalLogger;
    this.logger = null;

    this.callbacks = {};
  }

  get officeStore() { return this.meta.officeStore; }
  get requestStore() { return this.officeStore.requestStore; }
  get salesforceStore() { return this.officeStore.salesforceStore; }
  get userStore() { return this.officeStore.userStore; }
  get contextStore() { return this.officeStore.contextStore; }

  get context() { return this.meta.context; }
  get cancelToken() { return this.meta.cancelToken; }
  get userStoreToken() { return this.userStore.token; }

  async run() {
    try {
      await this._createLogger_();
      this.fireEvent('started');

      const result = { warnings: [], ...await this._run_() };
      this.fireEvent('finished', result);
      return result;
    }
    catch (error) {
      console.error('Runnable::run:catch: ', error.message);
      console.error('Runnable::run: ', error.stack);
      this.fireEventWithoutCancelationCheck('error', error);
      return { error, warnings: [] };
    }
    finally {
      await this.contextStore.updateNamedRanges();
      this.logger.close();
      await this.sync();
    }    
  }

  on(eventName, callback) {
    this.callbacks[eventName] = callback;
    return this;
  }

  async setTimestampCellValue({ customRange, address, worksheetId, worksheetInstance }, ts) {
    let worksheet = worksheetInstance;
    let localAddress = address;
    if (customRange) {
      await this.contextStore.updateNamedRanges();
      const rangeAddress = this.contextStore.getNamedRangeAddress(customRange);
      if (!rangeAddress) {
        throw new Error(`Cannot find named range '${customRange}' to set last run time`);
      }
      localAddress = rangeAddress.getFirstCell().shortAddress;
      worksheet = this.contextStore.getWorksheet({ name: rangeAddress.worksheetName });
    }
    else if (worksheetId) {
      worksheet = this.contextStore.getWorksheet({ id: worksheetId });
      if (!worksheet) {
        throw new Error(`Cannot find worksheet with id '${worksheetId}' to set last run time`);
      }
      localAddress = address;
    }

    if (worksheet && localAddress) {
      console.log(`Last update time for '${this.name}' in '${worksheet.name}!${localAddress}' :`, ts);
      worksheet = this.context.workbook.worksheets.getItem(worksheet.id);
      worksheet.getRange(localAddress).values = [[ts]];
    }
  }

  createLogger(props) {
    this.logger = new InstanceLogger(this.globalLogger, 
      { ...props, userName: this.officeStore.userStore.userName }, this.parent?.logger);
  }

  async sync() {
    await this.context.sync();
  }

  fireEvent(eventName, ...eventArgs) {
    this.cancelToken.throwIfRequested();
    this.fireEventWithoutCancelationCheck(eventName, ...eventArgs);
  }

  fireEventWithoutCancelationCheck(eventName, ...eventArgs) {
    const e = this.callbacks[eventName];
    // e && console.log('Runnable::fire: ', eventName);
    e && e(this, ...eventArgs);
  }
};


export async function selectRange(range) {
  range.select();
  range.untrack();
  await range.context.sync();
}


export default Runnable;